module.exports = __webpack_public_path__ + "static/img/dibu.c9381ce4.png";